import { RealCurrentUser } from './realCurrentUser';
import ConsentState from '../../../marketing/ConsentState';
import { container } from '../../../utils/container/container';
import { ServiceIds } from '../../../utils/container/service-ids';
import { isTestMode } from '../utilityFunctions';
import { KVCache } from '../../../cache/kvCache';
import { CacheKeys } from '../../../cache/cacheKeys';
import { ConsentSources } from '../../../constants/ConsentSources';
import { CurrentEntryPoint } from '../../../constants/CurrentEntryPoint';

export class CurrentUser {
    private static userInstance: CurrentUser;

    // eslint-disable-next-line no-useless-constructor,no-empty-function
    private constructor() {}

    public getAccountId(): number {
        const number = parseInt(<string>window.app.user_huid);
        if (!window.app.user_huid || isNaN(number)) {
            throw new Error('User is unauthorized or invalid account id passed from backend');
        }
        return number;
    }

    public getSuid(): string {
        if (isTestMode()) {
            if (window.app.config.suid_simulate) {
                return window.app.config.suid_simulate;
            }
        }

        return RealCurrentUser.getInstance().getSuid();
    }

    public getGuid(): [number, number] {
        const guid = window.app.getGameStartDataResponse?.guid;
        return guid;
    }

    public async getConsentState(): Promise<number> {
        const consentState = new ConsentState();
        const consent = (await consentState.getConsentState()).consent;
        return consent;
    }

    public setConsentState(email: string, consent: boolean, consentEntryPoint: ConsentSources) {
        const consentState = new ConsentState();
        return consentState.setState(consent, email, consentEntryPoint);
    }

    public getEmail(): string {
        if (window.app.config.regEmail) {
            return window.app.config.regEmail;
        }

        return undefined;
    }

    public setEmail(email: string) {
        window.app.config.regEmail = email;
    }

    public getPaymentEmail(): string {
        if (window.app.config.regEmail) {
            return window.app.config.regEmail;
        }

        const cachedEmail = KVCache.getInstance().get(CacheKeys.USER_EMAIL_ADDRESS);
        if (typeof cachedEmail === 'string') {
            return cachedEmail;
        }

        return undefined;
    }

    public setPaymentEmail(email: string) {
        // TODO check wtf is this
        window.app.config.regEmail = email;
        KVCache.getInstance().set(CacheKeys.USER_EMAIL_ADDRESS, email);
    }

    public getAuthToken(): string {
        return window.app?.config?.user_auth_token;
    }

    public isSimulate(): boolean {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const config = container.get<any>(ServiceIds.CONFIG);
        return !!config.suid_simulate;
    }

    public getCity(): string {
        return window.app?.user?.city;
    }

    public getFullName(): string {
        return window.app?.user?.full_name;
    }

    public getGender(): number {
        return window.app.user.gender;
    }

    public getRef(): string {
        return window.app.config.ref;
    }

    public getEntryPoint(): CurrentEntryPoint {
        return window.app?.config?.current_entry_point;
    }

    public getHasGuestAuthMethod(): boolean {
        return window.app?.config?.hasGuestAuthMethod;
    }

    public getExternalId(): string {
        return window.app?.config?.externalId;
    }

    public getCountryCode(): string|null {
        const countryCode = window.app?.config?.country;
        return countryCode ? countryCode.toUpperCase() : null;
    }

    public static getInstance(): CurrentUser {
        if (typeof CurrentUser.userInstance === 'undefined') {
            CurrentUser.userInstance = new CurrentUser();
        }

        return CurrentUser.userInstance;
    }
}
